import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';

function App() {

  return (
    <>
      <Outlet />
      <ToastContainer position='top-right' />
      <Toaster />
    </>
  );
}

export default App;
